import React from 'react';
import { AlgoversePaymentModalProps } from '../types.type';
import AlgoverseModalComponent from 'v3/common/components/Algoverse/ModalComponent';
import { useAlgoversePayment } from '../hook/useAlgoversePayment';
import { getPaymentUIConfig } from '../getPaymentUIConfig';

const AlgoversePaymentModal: React.FC<AlgoversePaymentModalProps> = ({
  orderId,
  showModal,
  setShowModal,
  selectedPlan,
}) => {
  const payment = useAlgoversePayment({ orderId, selectedPlan, showModal, setShowModal });
  const paymentUIConfig = getPaymentUIConfig({ ...payment, selectedPlan })[payment.paymentStatus];

  return (
    <AlgoverseModalComponent
      backdrop="static"
      className="algoverse-payment-modal"
      renderTitle={paymentUIConfig.title}
      onClose={() => setShowModal(false)}
      isOpen={showModal}
      renderBodyComponent={paymentUIConfig.renderBody()}
      renderFooterComponent={paymentUIConfig.renderFooter()}
    />
  );
};

export default AlgoversePaymentModal;
